<div class="logout-page">
  <img src="./assets/{{ logoFile }}" class="logo" alt="Imagine" height="80" width="250" />
  <div>Logging out, please wait......</div>
</div>
